export { DocHero } from './DocHero';
